import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  legacySettingsSearchSchema,
  settingsTargetOf,
} from '@/features/settings';

/**
 * The entry's own address, and every address Settings had before its tabs were
 * addresses (spec 227 FR-007): `?tab=`, `?section=` and `?create` are carried to
 * the tab they meant. Replaced, not pushed, so Back from the landed tab leaves
 * Settings as it did before.
 */
export const Route = createFileRoute('/workspaces/$workspaceId/settings/')({
  validateSearch: legacySettingsSearchSchema,
  beforeLoad: ({ params, search }) => {
    const target = settingsTargetOf(search);
    const base = { params: { workspaceId: params.workspaceId }, replace: true };
    // TanStack Router signals a redirect by throwing its own marker object, not
    // an Error. This is the framework's documented control flow.
    /* eslint-disable @typescript-eslint/only-throw-error */
    switch (target.tab) {
      case 'people':
        throw redirect({
          ...base,
          to: '/workspaces/$workspaceId/settings/people',
          search: target.section ? { section: target.section } : {},
        });
      case 'images':
        throw redirect({
          ...base,
          to: '/workspaces/$workspaceId/settings/images',
          search: target.create ? { create: true } : {},
        });
      case 'activity':
        throw redirect({
          ...base,
          to: '/workspaces/$workspaceId/settings/activity',
        });
      case 'labels':
        throw redirect({
          ...base,
          to: '/workspaces/$workspaceId/settings/labels',
        });
      case 'general':
        throw redirect({
          ...base,
          to: '/workspaces/$workspaceId/settings/general',
        });
    }
    /* eslint-enable @typescript-eslint/only-throw-error */
  },
});
